import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "befb5e4f-97cf-4e0b-943d-ae48d60ae11e",
    content: "An outlet with high airspeed",
    options: {},
  },
  {
    id: "6e4956dc-69de-4333-9b9b-200a756e60d2",
    content: "An air plenum",
    options: {},
  },
  {
    id: "83c222a8-08dc-4197-9248-133831064ce5",
    content: "A silencer of 50cm length",
    options: {},
  },
  {
    id: "bf487165-c7a3-40d7-afc1-ae651ec0b68c",
    content: "A volume damper",
    options: {},
  },
];

export const task: Task = {
  id: "92e2a553-58fb-4293-8593-52cc28d3e056",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["6e4956dc-69de-4333-9b9b-200a756e60d2", "83c222a8-08dc-4197-9248-133831064ce5"],
};
